const state = {
  toplistQuery: {
    columns: [],
    groupBy: { label: "Day", id: "day" },
    day: "",
    week: "",
    channels: {},
    measures: [],
    key_column: {
      column_type: "'dim_program'[program_key]",
      display_name: "ProgramKey"
    }
  },
  toplistQueryResult: {
    columns: [],
    groupBy: { label: "Day", id: "day" },
    day: "",
    week: "",
    channels: "",
    measures: []
  },
  toplistResults: {
    status: "NOT_LOADED"
  }
};
const getters = {
  getToplistQuery: state => state.toplistQuery,
  getToplistQueryResult: state => state.toplistQueryResult,
  getToplistResults: state => state.toplistResults
};
const mutations = {
  setToplistQuery: (state, payload) => (state.toplistQuery = payload),
  setToplistQueryResult: (state, payload) =>
    (state.toplistQueryResult = payload),
  setToplistResult: (state, payload) => (state.toplistResults = payload),
  setDay: (state, payload) => (state.toplistQuery.day = payload)
};
export default {
  state,
  getters,
  mutations
};
